import React from 'react';

export default function Section({ typename: type, ...props }) {
    let SectionComponent = () => null;

    const SECTIONS = {
        DatoCmsHeroComboSection: require('./components/HeroComboSection')
            .default,
        DatoCmsHeroHomeSection: require('./components/HeroHomeSection').default,
        DatoCmsBandLogosSection: require('./components/BandLogosSection')
            .default,
        DatoCmsBlockContentLargeSection:
            require('./components/BlockContentLargeSection').default,
        DatoCmsMediaFullSection: require('./components/MediaFullSection')
            .default,
        DatoCmsBlockDemoSection: require('./components/BlockDemoSection')
            .default,
        DatoCmsFormSection: require('./components/FormSection').default,
        DatoCmsBannerNewsletterSection:
            require('./components/BannerNewsletterSection').default,
        DatoCmsCalculatorSection: require('./components/CalculatorSection')
            .default,
        DatoCmsBannerLargeSection: require('./components/BannerLargeSection')
            .default,
        DatoCmsBannerSmallSection: require('./components/BannerSmallSection')
            .default,
        DatoCmsContactTourSection: require('./components/ContactTourSection')
            .default,
        DatoCmsBlockTitleLargeSection:
            require('./components/BlockTitleLargeSection').default,
        DatoCmsBlockTitleSmallSection:
            require('./components/BlockTitleSmallSection').default,
        DatoCmsBlockWorldSection: require('./components/BlockWorldSection')
            .default,
        DatoCmsGlossarySection: require('./components/GlossarySection').default,
        DatoCmsGridPricingSection: require('./components/GridPricingSection')
            .default,
        DatoCmsPricingDetailsTable:
            require('./components/PricingDetailsSection').default,
        DatoCmsAwardsSection: require('./components/AwardsSection').default,
        DatoCmsGallerySection: require('./components/GallerySection').default,
        DatoCmsStorySection: require('./components/StorySection').default,
        DatoCmsBlogSection: require('./components/BlogSection').default,
        DatoCmsBlockTrustSection: require('./components/BlockTrustSection')
            .default,
        DatoCmsBlockColumnsSection: require('./components/BlockColumnsSection')
            .default,
        DatoCmsAccordion3Section: require('./components/Accordion3Section')
            .default,
        DatoCmsBlockListLargeSection:
            require('./components/BlockListLargeSection').default,
        DatoCmsGridInfo1Section: require('./components/GridInfo1Section')
            .default,
        DatoCmsGridInfo2Section: require('./components/GridInfo2Section')
            .default,
        DatoCmsGridInfo3Section: require('./components/GridInfo3Section')
            .default,
        DatoCmsCarousel1Section: require('./components/Carousel1Section')
            .default,
        DatoCmsGridNavigation1Section:
            require('./components/GridNavigation1Section').default,
        DatoCmsGridNavigation2Section:
            require('./components/GridNavigation2Section').default,
        DatoCmsPressSection: require('./components/PressSection').default,
        DatoCmsGridNavigation3Section:
            require('./components/GridNavigation3Section').default,
        DatoCmsBlockFaqsSection: require('./components/BlockFaqsSection')
            .default,
        DatoCmsTableSection: require('./components/TableSection').default,
        DatoCmsResourcesSection: require('./components/ResourcesSection')
            .default,
        DatoCmsRichTextSection: require('./components/RichTextSection').default,
        DatoCmsJoinCommunitySection:
            require('./components/JoinCommunitySection').default,
        DatoCmsStoriesSection: require('./components/StoriesSection').default,
    };

    SectionComponent = SECTIONS?.[type] ?? null;

    return SectionComponent ? <SectionComponent {...props} /> : null;
}
